import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { DomSanitizer } from '@angular/platform-browser';
import * as moment from 'moment';
import { DialogBase, PriceModel, RentalInfo, RentalStatus, RequestDetails, ReturnResultAction, ReturnResultCode, ReturnValidation, ReturnValidationResult, SparepartPriceModel } from 't4core';
import { CreateServiceRequestDialog } from '../createServiceRequestDialog/createServiceRequestDialog';



@Component({
    selector: 'dialog-returnDialog',
    templateUrl: './returnDialog.html',
    styleUrls: ['./returnDialog.css'],
    //changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReturnDialog extends DialogBase implements OnInit {
    // <ViewModel>
    public booking: RentalInfo = new RentalInfo();
    public actualTrailer: string = "";

    @ViewChild("stepper", {static: false})
    public stepper: MatStepper;

    public steps = [{
        Index: 0,
        Name: 'Confirm object',
        Active: true,
        isCompleted: false
    },
        {
            Index: 1,
            Name: 'Change object',
            Active: false,
            isCompleted: false
        },
        {
            Index: 2,
            Name: 'Rental check',
            Active: true,
            isCompleted: false
        },
        {
            Index: 3,
            Name: 'Damages',
            Active: true,
            isCompleted: false
        }];
    public localLoaders = {
        return: false,
    };

    // Return
    public returnTime: moment.Moment = this.round(moment(), 15, 'minute');
    public returnValidation: ReturnValidation = new ReturnValidation();

    public damageCostAdded : boolean = false;

    public returnActionRequired(): Boolean {
        if (!this.returnValidation) return false;

        if (this.returnValidation.Action == ReturnResultAction.Unspecified) {
            if (this.returnValidation.Result == ReturnValidationResult.Changed) return true;
            if (this.returnValidation.Result == ReturnValidationResult.Late) return true;
            if (this.returnValidation.Result == ReturnValidationResult.WrongLocation) return true;
        }

        return false;
    }
    // </ViewModel>

   
    constructor(
      public dialogRef: MatDialogRef<ReturnDialog>,
      @Inject(MAT_DIALOG_DATA) public params: any,
        private sanitizer: DomSanitizer,
      private _cdr: ChangeDetectorRef
  ) {
        super("ReturnDialog");
        this.returnValidation.ReturnPrice = new PriceModel();
    }

    async ngOnInit() {

        var token = "";

        if (this.params.booking) {
            this.booking = this.params.booking;
            if (!this.booking.IsOneWay)
                token = this.beginLoad("Turbo.Core.Dialogs.ReturnDialog.ldrRental", "Checking booking...", null);

            if (this.Settings.clientSettings.RentalLocationId && this.Settings.clientSettings.RentalLocationId != this.booking.ReturnLocationId) {
                this.booking.ReturnLocationId = this.Settings.clientSettings.RentalLocationId;
            }

            this.steps[0].Active = this.booking.IsOneWay;
            this.steps[0].isCompleted = this.booking.IsOneWay;

            await this.checkBookingForReturn();
            this.endLoad(token);
        }
        else {
            this.dialogRef.close();
        }
    }

    // <Steps>
    public async confirmTrailer() {
        //var result = await this.Dialog.open(PinDialog, { data: { retry: '' } }).afterClosed().toPromise();
        //if (result) {
            this.steps[0].isCompleted = true;
            this.steps[1].isCompleted = true;
            this.stepper.next();
        //}
    }
    public changeObject() {
        this.steps[0].isCompleted = true;
        this.steps[1].Active = true;
        this.steps[1].isCompleted = false;
        this.stepper.next();
    }
    // </Steps>

    // <Commands>
    public validateActualTrailer() {
        if (this.actualTrailer) {
            this.steps[1].isCompleted = true;
        }
    }
    public async confirmAdditionalPayment() {
        this.returnValidation.Action = ReturnResultAction.Confirm;
        this.steps[2].isCompleted = true;
        await new Promise(resolve => setTimeout(resolve, 200));
        this.stepper.next();
    }
    public async rejectAdditionalPayment() {
      this.returnValidation.Action = ReturnResultAction.Ignore;
      if (await this.Api.post<number>("Price/AddCost", null, { itemId: 1060, amount: -this.returnValidation.ReturnPrice.DiscountedTotalPrice, description: "The addional cost is ignored by the user.", rentalId: this.booking.Id })) {
        this.steps[2].isCompleted = true;
        await new Promise(resolve => setTimeout(resolve, 200));
        this.stepper.next();
      }
    }
    public async reportDamages() {

      var ret = await this.UI.openDialog("T4.Bookings.CostListDialog", { data: { rentalId: this.booking.Id } });

      if (ret != undefined) {
        this.returnValidation.Action = ReturnResultAction.Confirm;
        if (ret) {
          this.returnValidation.ReceiptExists = true;
          this.damageCostAdded  = true;
        }          
        this.processReturn();
      }
    }
    public async processReturn(addons: number[] = [], extraReason: string = "") {
        var token = this.beginLoad("Turbo.Core.Dialogs.ReturnDialog.msgReturning", "Returning booking...", null);

      var result = await this.Api.post<ReturnResultCode>("/Rental/Return", null,
        {
            rentalId: this.booking.Id,
            returnTime: this.returnTime.toISOString(),
            returnLocation: this.booking.ReturnLocationId,
            receiptAction: (this.returnValidation) ? this.returnValidation.Action : ReturnResultAction.Unspecified,
            bypassCardPayment: false,
            addons: addons,
            extraReason: extraReason
        });

        // Validations
      if (result == ReturnResultCode.LockOpen) {
            await this.UI.alert("Turbo.Core.Dialogs.ReturnDialog.errReturnFailed", "Return failed!", "Turbo.Core.Dialogs.ReturnDialog.errLockIsOpen", "The lock on this trailer is not closed. Please close the lock and try again.")
            return;
        }

      if (result == ReturnResultCode.NotAtLocation) {
            await this.UI.alert("Turbo.Core.Dialogs.ReturnDialog.errReturnFailed", "Return failed!", "Turbo.Core.Dialogs.ReturnDialog.errNotAtLocation", "The Trailer is not at the correct location. Please drive it back to the return location and try again.")
            return;
        }

      if (result == ReturnResultCode.PaymentActionRequired) {
            await this.UI.alert("Turbo.Core.Dialogs.ReturnDialog.errReturnFailed", "Return failed!", "Turbo.Core.Dialogs.ReturnDialog.errLockIsOpen", "Payment action is required")
            this.checkBookingForReturn();
            return;
        }

      while (result == ReturnResultCode.PaymentFailed) {
            var response = await this.UI.confirm("Turbo.Core.Dialogs.ReturnDialog.errPaymentFailed", "Card payment failed!", "Turbo.Core.Dialogs.ReturnDialog.errPaymentFailedText", "The credit card could not be charged. Do you want to try again?")
            if (response) {
                this.endLoad(token);
                this.processReturn();
                return;
            } else {
                await this.UI.alert("Turbo.Core.Dialogs.ReturnDialog.errManualPayment", "Important note!", "Turbo.Core.Dialogs.ReturnDialog.errLockIsOpen", "Turbo has not been able to charge the customer. Remember to collect payment from the customer manually! ")
              result = await this.Api.post<ReturnResultCode>("/Rental/Return", null,
                    {
                        rentalId: this.booking.Id,
                        returnTime: this.returnTime.toISOString(),
                        returnLocation: this.booking.ReturnLocationId,
                        receiptAction: (this.returnValidation) ? this.returnValidation.Action : ReturnResultAction.Unspecified,
                        bypassCardPayment: true,
                        addons: addons,
                        extraReason: extraReason
                    });
            }
        }

      if (result != ReturnResultCode.Success) {
            await this.UI.alert("Turbo.Core.Dialogs.ReturnDialog.errReturnFailed", "Return failed!", "Turbo.Core.Dialogs.ReturnDialog.errUnknown", "Unknown error")
            return;
        }

        this.Insights.logEvent("ReturnBooking");
        this.booking.Status = RentalStatus.Returned;
        this.booking.ReturnedAt = this.returnTime;
        this.booking.ExtraReceiptExists = this.returnValidation.ReceiptExists;
        this.booking.ExtraReceiptSkipped = this.returnValidation.Action == ReturnResultAction.Ignore;

        this.endLoad(token);

        var token = this.beginLoad("Turbo.Core.Dialogs.ReturnDialog.msgReturned", "Booking has been returned", null);
        await new Promise(resolve => setTimeout(resolve, 200));

        if (this.actualTrailer) {
            await this.Api.post<RequestDetails>("/Service/CreateRequest", null, {
                rentalObjectId: this.booking.RentalObject.Id,
                description: "Fel släp mottaget, " + this.actualTrailer + " kom istället. Bokningsnummer: " + this.booking.Id + " från " + this.booking.PickupLocation.Name,
                tags: 0,
                isInsuranceCase: false,
                disable: true
            });
        }

      if (this.booking.ExtraReceiptExists) {
           this.dialogRef.close({extraReceiptExists: true, damageCostAdded: this.damageCostAdded  });
        } else {
        this.dialogRef.close({ extraReceiptExists: false, damageCostAdded: this.damageCostAdded });
        }
        this.endLoad(token);      
    }

    public async checkBookingForReturn() {
        if (!this.booking) return;

        this.returnValidation = await this.Api.post<ReturnValidation>("/Rental/ValidateForReturn", null,
            {
                rentalId: this.booking.Id,
                returnTime: this.returnTime.toISOString(),
                pickupLocation: this.booking.PickupLocationId,
                returnLocation: this.booking.ReturnLocationId
            });

        this.steps[2].Active = (this.returnValidation.Result != ReturnValidationResult.Valid);
    }
    // </Commands>

    // <Helpers>
    private round(date: moment.Moment, precision: number, key: string): moment.Moment {
        var direction = 'round';

        var keys = ['Hours', 'Minutes', 'Seconds', 'Milliseconds'];
        var maxValues = [24, 60, 60, 1000];

        // Capitalize first letter
        key = key.charAt(0).toUpperCase() + key.slice(1).toLowerCase();

        // make sure key is plural
        if (key.indexOf('s', key.length - 1) === -1) {
            key += 's';
        }
        var value = 0;
        var rounded = false;
        var subRatio = 1;
        var maxValue;
        for (var i in keys) {
            var k = keys[i];
            if (k === key) {
                value = date.toDate()['get' + key]();
                maxValue = maxValues[i];
                rounded = true;
            } else if (rounded) {
                subRatio *= maxValues[i];
                value += date.toDate()['get' + k]() / subRatio;
                date.toDate()['set' + k](0);
            }
        };

        value = Math[direction](value / precision) * precision;
        value = Math.min(value, maxValue);
        var ret = moment(date.toDate()['set' + key](value));

        ret = ret.seconds(0);
        ret = ret.milliseconds(0);

        return ret;
    }
    // </Helpers>

    //public static async returnBooking(dialog: MatDialog, booking: RentalInfo): Promise<boolean> {
        
    //}
}
